import { cn } from "cn";

export function SectionContainer({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <section
      className={cn(
        "mx-auto flex w-full max-w-7xl items-center justify-center gap-8 py-0 md:p-6 2xl:p-12",
        className
      )}
    >
      {children}
    </section>
  );
}
